import React from 'react';

import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { ZoomZoneButton } from '../components/ZoomZoneButton';
import { useResponsive } from '../hooks/useResponsive';
import { openDataModal } from '../store/actions/modalActions';

export const ZoneSection = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOpenInfosModal = () => {
    dispatch(openDataModal());
  };

  return (
    <Stack 
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
      direction='row'
      spacing={1}
    >
      <Box sx={{
        display: 'flex',
        width: '100%',
        minWidth: '8em'
      }}>
        <ZoomZoneButton />
      </Box>
      <Box>
        <Tooltip title={
          <p style = {{
            fontSize: '1em',
          }}>
            {t('common.infos-data')}
          </p>
        } 
        placement={isMobile ? 'top-end' : 'bottom-start'}
        arrow>
          <IconButton  
            size='small'
            aria-label={t('common.infos-data')}
            sx={{
              width: '1.5em',
              height: '1.5em',
              color: 'primary.main',
              border: '1px solid ',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'white'
              }
            }}
            aria-haspopup="dialog"
            onClick={() => {
              handleOpenInfosModal();
            }}
          >
            <FontAwesomeIcon icon={faQuestion} />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};